/**
 * PortalProducts
 *
 * Handles the setting and getting of a products, and product groups
 */

// the constructor for this object
function PortalProducts() { }

// the object
PortalProducts.prototype = {
    constructor: PortalProducts,
    
    // make the api call to get the products data
    setProducts: function(successCallback)
    {
        var productsRequest = new PortalRequest;
        productsRequest.makeRequest(
            '/orders/get-products',
            {},
            function(data, code, message) {
                
                // save the products
                PortalMain.PortalProducts._storeProductsData(data);
                    
                // save the product groups
                PortalMain.PortalProducts._storeProductGroupsData(data);
                
                successCallback(true);
            },
            function () {
                successCallback(false);
            }
        );
    },
    
    // clear the products details from localstorage
    clearProducts: function()
    {
        localStorage.removeItem('portalProducts');
        localStorage.removeItem('portalProductGroups');
    },
    
    // get the products
    getProducts: function() 
    {
        if (localStorage.portalProducts) {
            var productsData = JSON.parse(localStorage.portalProducts);
            return productsData;
        }
        
        return [];
    },
    
    // get the products
    getProduct: function(productCd) 
    {
        var products = this.getProducts();
        var product = {};
        for (var i in products) {
            if (products[i].product_cd.toLowerCase() == productCd.toLowerCase()) {
                product = products[i];
            }
        }
        
        return product;
    },
    
    // get the product groups
    getProductGroups: function() 
    {
        if (localStorage.portalProductGroups) {
            var productGroupsData = JSON.parse(localStorage.portalProductGroups);
            return productGroupsData;
        }
        
        return [];
    },
    
    // get a specific product group
    getProductGroup: function(productGroup) 
    {
        productGroup = productGroup.replace(/\s+/g, '-').toLowerCase();
        
        var productGroups = this.getProductGroups();
        var returnGroup = {}
        for (var i in productGroups) {
            if (productGroups[i].path == productGroup) {
                returnGroup = productGroups[i];
            }
        }
        
        return returnGroup;
    },
    
    // get a specific product group by a product cd
    getProductGroupByProductCd: function(productCd) 
    {
        productCd = productCd.toUpperCase();
        
        var productGroups = this.getProductGroups();
        
        for (var i in productGroups) {
            if (productGroups[i].products.indexOf(productCd) != -1) {
                return productGroups[i];
            }
        }
        
        return false;
    },
    
    // create a link to an orders page 
    getProductLink: function(productCd, baseOrderId)
    {
        var product = this.getProduct(productCd);
        var productController =productCd.toLowerCase();
        if (product.product_controller != null) {
            productController = product.product_controller;
        }
        var productLink = PortalConfig.portalUrl;
        productLink += '/service/' + productController + '/' + baseOrderId;
        
        return productLink;
    },
    
    // save the products data to localstorage
    _storeProductsData: function(productsData)
    {
        productsData = JSON.stringify(productsData);
        localStorage.setItem('portalProducts', productsData);
    },
    
    // save the product groups to localstorage
    _storeProductGroupsData: function(products)
    {    
        // get all of the product groups
        var groups = [];
        var groupLabels = [];
        for (var i in products) {
            if (!products[i].active) {
                continue;
            }
            
            var productGroup = products[i].product_group;
            
            // the record does not exist
            if (groupLabels.indexOf(productGroup) == -1 && productGroup != null) {
                groupLabels.push(productGroup);
                groups.push({
                    label: productGroup,
                    path: productGroup.replace(/\s+/g, '-').toLowerCase(),
                    products: [products[i].product_cd]
                });
            
            // the record exists, so append the product cd
            } else if (productGroup != null) {
                for (var x in groups) {
                    var group = groups[x];
                    if (productGroup == group.label) {
                        groups[x].products.push(products[i].product_cd);
                    }
                }
            }
        }
        
        groups.sort(function(a, b) {
            return a.label > b.label;
        });
        
        var productGroups = JSON.stringify(groups);
        localStorage.setItem('portalProductGroups', productGroups);
    },
    
}
